import { EuiCard, EuiFlexItem } from '@elastic/eui';
import styled from '@emotion/styled';

export const Card = styled(EuiCard)`
  margin-top: 50px;
  width: 100%;
  border-radius: 13px !important;
  height: 95% !important;
  border: none;
  overflow-y: auto;
`;

export const Row = styled(EuiFlexItem)`
  padding-bottom: 20px;
  border-bottom: 1px solid #e9edf3;
  cursor: pointer;
  .delete {
    color: rgb(245, 101, 28);
  }
`;
